<template>
  <div>
    <div class="indexHeader">
      <div class="swiper-container">
        <div class="swiper-wrapper">
            <div class="swiper-slide">
              <img src="@/assets/banner1.png" />
            </div>
            <div class="swiper-slide">
              <img src="@/assets/banner2.png" />
            </div>
        </div>
        <div class="swiper-pagination"></div>
      </div>
    </div>
    <div class="panel p0">
      <div class="w1200">
        <div class="item">
          <b>一体化教学模式</b>
          <span>AI可视化创意编程软件及系统</span>
        </div>
        <div class="item">
          <b>人工智能教学</b>
          <span>开展人工智能实验教学课程</span>
        </div>
        <div class="item">
          <b>多元化教学场景</b>
          <span>向基础教育阶段学生提供多元教学场景</span>
        </div>
        <div class="item">
          <b>定制化解决方案</b>
          <span>定制化人工智能教育全方位解决方案</span>
        </div>
      </div>
    </div>
    <div class="panel p1">
      <img src="@/assets/pt_bg.png" class="bg" />
      <h2>平台介绍</h2>
      <div class="w1200">
        <div class="left">
          <b>人工智能教育学习平台</b>
          <p>威盛人工智能实验教学服务平台是一个专为人工智能教育研发的综合型教育平台，以全新的教育信息化概念为核心，构建满足教学、管理、实践、学习、实验、应用、创新的一体化模式。</p>
          <p>自2016年12月以来，威盛电子布局人工智能教育领域，致力于人工智能教育的普及与推广，通过在人工智能领域的强大技术实力，打造从教学到实践的人工智能教育生态循环教学链。</p>
          <router-link :to="{path: '/ptjs'}" class="btn">了解更多</router-link>
        </div>
        <img :src="require('@/assets/pt_img.png')" class="right" />
      </div>
    </div>
    <div class="panel_1200 p2">
      <h2>师资队伍</h2>
      <div class="swiper-container-sz">
        <div class="swiper-wrapper">
            <div class="swiper-slide" v-for="(item, index) in szlist" :key="index">
              <img src="@/assets/sz_img_bg.png" class="cardBg" />
              <div class="left">
                <div class="name">{{item.name}}</div>
                <div class="from">{{item.from}}</div>
                <div class="desc">{{item.desc}}</div>
                <div class="btn" @click="teacherDetail(item)">详情</div>
                <!-- <router-link :to="{path: '/szdw/'+item.id}" class="btn">详情</router-link> -->
              </div>
              <img :src="require('@/assets/' + item.picB)" class="right" />
              <div class="bottom">
                <img
                  v-for="(_item, _index) in szlist" :key="_index"
                  :src="require('@/assets/' + _item.pic)"
                  :class="index == _index ? ['active']:[]"
                  @click="swiperPage(_index)"
                />
              </div>
            </div>
        </div>
        <div class="swiper-button-prev"></div>
        <div class="swiper-button-next"></div>
      </div>
    </div>
    <div class="panel p3">
      <div class="w1200">
        <h2>资质信息</h2>
        <div class="zzCard" v-for="(item, index) in zzlist" :key="index">
          <img :src="require('@/assets/'+item.pic2)" class="bg" />
          <div class="tit">
            <img :src="require('@/assets/'+item.pic1)" class="icon" />
            <b>{{item.name}}</b>
          </div>
          <p>{{item.desc}}</p>
          <span class="btn" @click="zizhiDetail(item)">了解更多</span>
        </div>
      </div>
      <img src="@/assets/xm_img_bg.png" class="p3After" />
    </div>
    <div class="panel p4">
      <h2>威盛人工智能教育项目</h2>
      <h6>从五个维度出发，制定了人工智能教育战略</h6>
      <img src="@/assets/xm_img.png" class="img" />
    </div>
    <div class="panel p5">
      <h2>威盛人工智能研究院</h2>
      <h6>聚焦人工智能基础研究，布局人工智能未来发展方向，为行业和社会提供发展战略指导</h6>
      <div class="swiper-container-p5">
        <div class="swiper-wrapper">
            <div class="swiper-slide">
              <div class="p">
                以企业社会责任为出发点，整合社会资源，共享在AI领域的先进科学技术和资源优势，在人工智能相关的垂直行业领域深入发展，成为技术标准化的倡导者和行业专业化的领军者，谋求技术进步和产、学、研相结合的可持续发展。
              </div>
              <img src="@/assets/yjy_img1.png" class="img" />
            </div>
            <div class="swiper-slide">
              <div class="p">
                自2018年成立起，威盛人工智能研究院就一直活跃在校园AI教育一线，普及人工智能技术、思维和结构，深耕教育事业，联合社会各界的力量，积极倡导和推进人工智能与小学、中学、中高职、大专院校等教育教学的融合发展，致力于青少年人工智能教育的教学研究。
              </div>
              <img src="@/assets/yjy_img2.png" class="img" />
            </div>
        </div>
        <div class="swiper-pagination"></div>
      </div>
    </div>
    <teacherPop v-if="teacherPopShow" :item="teacherItem" v-on:close="popHide"></teacherPop>
    <zizhiPop v-if="zizhiPopShow" :item="zizhiItem" v-on:close="popHide"></zizhiPop>
  </div>
</template>

<script>
let _swiper = null
import Swiper from 'swiper'
import 'swiper/css/swiper.min.css'
import teacherPop from '@/components/teacherPop.vue'
import zizhiPop from '@/components/zizhiPop.vue'
export default {
  name: 'index',
  components: {
    teacherPop,
    zizhiPop
  },
  data() {
    return {
      teacherItem: {},
      teacherPopShow: false,
      zizhiItem: {},
      zizhiPopShow: false,
      szlist: [{
          id: 1,
          name: '张进',
          from: '威盛人工智能研究院',
          desc: '威盛人工智能研究院赛事辅导专家，威盛人工智能研究院金牌培训讲师，具有多年丰富的国家级赛事辅导经验，多次承担教育部白名单赛事人工智能项目赛事培训工作。每年为全国各省级赛区提供超50场线上及线下培训，辅导学员多次获得国家级赛事一等奖，擅长作品创意及制作、多领域人工智能技术的交叉设计。',
          picB: 'sz_img_big1.png',
          pic: 'sz_img_s1.png'
        },{
          id: 2,
          name: '冯如振',
          from: '威盛人工智能研究院',
          desc: '威盛人工智能研究院技术工程师、高级讲师、高级嵌入式软件工程师、高级系统集成管理工程师，曾担任中国航天科技空气动力技术研究院无人机工程师、东部战区陆航直升机旅无人机技术讲师、国网高级技术顾问，专注技术领域包括航空航天、人工智能、计算机科学等领域，具备多年高科技智能硬件产品研发经验及丰富的技术培训经验。',
          picB: 'sz_img_big2.png',
          pic: 'sz_img_s2.png'
        },{
          id: 3,
          name: '李向君',
          from: '威盛人工智能研究院',
          desc: '威盛人工智能研究院技术支持专家、高级讲师具有丰富的现场支持经验，具有人工智能软硬件开发和调优方面、赛事指导培训等实际经验，为全国各地及国家级活动提供现场技术支持工作及赛事指导工作。',
          picB: 'sz_img_big3.png',
          pic: 'sz_img_s3.png'
        },{
          id: 4,
          name: '王宇',
          from: '威盛人工智能研究院',
          desc: '威盛人工智能研究院技术解决方案专家、高级讲师，威盛人工智能研究院技术研发专家。近十年人工智能软硬件研究经验，参与创造栗多个产品设计研发项目，熟悉机器学习常用算法，熟悉各种深度学习模型，熟悉常用的深度学习开源软件，为上百所中小学学校开展人工智能课程提供技术解决方案。',
          picB: 'sz_img_big4.png',
          pic: 'sz_img_s4.png'
        },{
          id: 5,
          name: '刘凯铭',
          from: '威盛人工智能研究院',
          desc: '威盛人工智能研究院技术支持专家、高级讲师，具有丰富的现场支持经验，具有人工智能软硬件开发和调优方面等实际经验，为全国各地及国家级活动提供现场技术支持工作。每年为全国各省市提供超过50场线上及线下技术培训。河南鹤壁首批人工智能试点学校教师培训主讲教师。',
          picB: 'sz_img_big5.png',
          pic: 'sz_img_s5.png'
        },{
          id: 6,
          name: '任延涛',
          from: '威盛人工智能研究院',
          desc: '威盛人工智能研究院技术支持专家、高级讲师具有丰富的现场支持经验，具有人工智能软硬件开发和调优方面、课程研发等实际经验，为全国各地及国家级活动提供现场技术支持工作及课程研发工作。',
          picB: 'sz_img_big6.png',
          pic: 'sz_img_s6.png'
      }],
      zzlist: [{
          id: 1,
          name: '研发实力',
          desc: '超过30年科技研发经验，全球高集成嵌入式平台及解决方案领导厂商，掌握“芯片级”核心技术，有芯片级三位一体的设计运营能力。',
          pic1: 'zz_icon1.png',
          pic2: 'zz_icon_b1.png',
        },{
          id: 2,
          name: '教育情怀',
          desc: '多年的教育情怀致力于培养科技型人才，从K12人工智能科普教育，到职业院校智能网联、智能驾驶专业共建，到高校FPGA芯片设计、人工智能算法，提供硬件、软件、技术、课程、竞赛、考试等全方位的产、学、研产教融合解决方案。',
          pic1: 'zz_icon2.png',
          pic2: 'zz_icon_b2.png',
        },{
          id: 3,
          name: '中国芯计算机表演赛',
          desc: '1989年，由工信部、卫计委、全国妇联、全国残联、中国优生优育协会、中国科协、中国儿基会、关工委联合发起、共同主办中华学习机表演赛，落实邓小平同志“计算机的普及要从娃娃做起”的伟大号召。威盛从2006年开始独家赞助与承办比赛，将影响力扩大到全国。每届参赛选手超过500万，培训教师万余人，覆盖全国30个省级赛区，已成为新中国成立以来坚持时间最长、规模最大、普及面最广、科技含量最高、公益性最强的儿童青少年科技普及教育活动，至今为止，共承办了14届（2006年-2019年）。',
          pic1: 'zz_icon3.png',
          pic2: 'zz_icon_b3.png',
        },{
          id: 4,
          name: '团体标准',
          desc: '2022年5月，全国高等学校计算机教育研究会与全国高等院校计算机基础教育研究会，共同发布了全国信息技术标准化技术委员会教育技术分技术委员会（CELTSC）团体标准-青少年编程能力等级：第五部分人工智能编程标准（T/CERACU/AFCEC 100.5）。<br/>威盛作为考试标准主要起草单位之一，与清华大学 、南开大学 、东南 大学 、北京邮电大学 、华东师范大学等高校团体组织共同起草此项标准。',
          pic1: 'zz_icon4.png',
          pic2: 'zz_icon_b4.png',
        },{
          id: 5,
          name: '教材编撰',
          desc: '有丰富的K12课程开发经验，多次参与高中新课标与义务教育国编教材教铺编撰工作。',
          pic1: 'zz_icon5.png',
          pic2: 'zz_icon_b5.png',
        },{
          id: 6,
          name: '蓝皮书优秀案例',
          desc: '被选入教育装备中心新技术在基础教育应用蓝皮书核心优秀案例；参与教育部教育装备研究与发展中心中小学人工智能装备标准制定工作。',
          pic1: 'zz_icon6.png',
          pic2: 'zz_icon_b6.png',
        },{
          id: 7,
          name: '国际级赛事能力',
          desc: '能与国际接轨，具有举办国际级赛事能力。',
          pic1: 'zz_icon7.png',
          pic2: 'zz_icon_b7.png',
        },{
          id: 8,
          name: '师资认证',
          desc: '具有丰富的师资培训经验，能很好办理各类师资认证。',
          pic1: 'zz_icon8.png',
          pic2: 'zz_icon_b8.png',
        },{
          id: 9,
          name: '研学培训',
          desc: '具有举办各类研学营经验，能很好办理各类研学培训。',
          pic1: 'zz_icon9.png',
          pic2: 'zz_icon_b9.png',
      }]
    }
  },
  mounted() {
    this.init()
  },
  methods: {
    init() {
      // swiper
      /* eslint-disable */
      let indexSwiper = new Swiper ('.swiper-container', {
        autoplay: {
          delay: 10000,
          disableOnInteraction: false,
        },
        loop: true,
        pagination: {
          el: '.swiper-pagination',
          clickable: true,
        }
     })
     _swiper = new Swiper ('.swiper-container-sz', {
        autoplay: false,
        loop: true,
        effect: 'fade',
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        }
     })
     let _swiper2 = new Swiper ('.swiper-container-p5', {
       autoplay: {
         delay: 10000,
         disableOnInteraction: false,
       },
       loop: true,
       pagination: {
         el: '.swiper-pagination',
         clickable: true,
       }
     })
     /* eslint-disable */
    },
    swiperPage(page) {
      _swiper.slideTo(page+1,500,false);
    },
    teacherDetail(_item) {
      this.teacherItem = _item
      this.teacherPopShow = true
    },
    zizhiDetail(_item) {
      this.zizhiItem = _item
      this.zizhiPopShow = true
    },
    popHide() {
      this.teacherItem = {}
      this.teacherPopShow = false
      this.zizhiItem = {}
      this.zizhiPopShow = false
    }
  }
}
</script>

<style scoped>
* {box-sizing: border-box;}
.panel{width: 100%;position: relative;z-index: 1;}
.panel_1200{width: 1200px;margin: 0 auto;position: relative;z-index: 1}
.w1200{width: 1200px;margin: 0 auto;}
.p0{height: 160px;background: url(../../assets/ys_bg.png);background-size: 100% 100%;}
.p0 .w1200{display: flex;flex-direction: row;align-items: center;height: 160px;}
.p0 .w1200 .item{flex:1;text-align: left;}
.p0 .w1200 .item b{color: #000;font-size: 20px;font-weight: bold;display: block;margin-bottom: 13px;}
.p0 .w1200 .item span{color: #666;font-size: 16px;font-weight: normal;display: block;}
.p1{height: 668px;overflow: hidden;padding-top: 100px;}
.p1 .bg{width: 100%;height: auto;position: absolute;z-index: 1;right: 0;bottom: 0;}
.p1 *{position: relative;z-index: 2;}
.p1 h2{text-align: center;font-size: 40px;color: #000;font-weight: bold;margin-bottom: 36px;display: block;}
.p1 .w1200{display: flex;flex-direction: row;align-items: flex-start;}
.p1 .left{display: inline-block;width: 500px;margin-right: 200px;padding-top: 75px;}
.p1 .left b{display: block;color: #000;font-size: 24px;font-weight: bold;text-align: left;margin-bottom: 20px;line-height: 36px;}
.p1 .left p{display: block;text-align: justify;color: #666;font-size: 16px;line-height: 28px;text-indent: 0;margin-bottom: 20px;}
.p1 .left .btn{display: inline-block;margin-top: 40px;width: 112px;height: 36px;line-height: 36px;text-align: center;border-radius: 19px;background-color: #fff;border: 1px solid #0E4AFA;color: #0E4AFA;font-size: 14px;cursor: pointer;}
.p1 .left .btn:hover{color: rgba(14, 74, 250, 0.5)}
.p1 .right{display: inline-block;width: 459px;height: 479px;}
.p2{padding-top: 100px;padding-bottom: 100px;width: 1350px;}
.p2 h2{text-align: center;font-size: 40px;color: #000;font-weight: bold;margin-bottom: 60px;display: block;}
.p2 .swiper-container-sz,.p2 .swiper-wrapper{width: 100%;height: 600px;position: relative;}
.p2 .swiper-container-sz{overflow: hidden;}
.p2 .swiper-slide{width: 100%;height: 100%;position: relative;z-index: 1;background-color: #fff;}
.swiper-button-prev:after, .swiper-container-rtl .swiper-button-next:after{content: none;}
.swiper-button-next:after, .swiper-container-rtl .swiper-button-prev:after{content: none;}
.p2 .swiper-button-prev{width: 74px;height: 75px;position: absolute;left: 0;top: 220px;background: url(../../assets/sz_left0.png);cursor: pointer;}
.p2 .swiper-button-prev:hover{background: url(../../assets/sz_left.png);}
.p2 .swiper-button-next{width: 74px;height: 75px;position: absolute;right: 0;top: 220px;background: url(../../assets/sz_right0.png);cursor: pointer;}
.p2 .swiper-button-next:hover{background: url(../../assets/sz_right.png);}
.p2 .swiper-slide .cardBg{width: 761px;height: 434px;position: absolute;top: 41px;left: 86px;z-index: 1;}
.p2 .swiper-slide .left{width: 761px;height: 434px;position: absolute;top: 41px;left: 86px;z-index: 2;padding-top: 79px;padding-left: 48px;padding-right: 48px;}
.p2 .swiper-slide .right{width: 485px;height: 596px;position: absolute;right: 73px;top: 2px;z-index: 2;}
.p2 .swiper-slide .bottom{width: 700px;height: 80px;position: absolute;bottom: 13px;left: 133px;z-index: 2;}
.p2 .swiper-slide .left .name{color: #0E4AFA;font-size: 36px;font-weight: bold;position: relative;margin-bottom: 48px;}
.p2 .swiper-slide .left .name:after{content:'';width: 34px;height: 9px;background-color: #09EBFF;border-radius: 0 100px 0 100px;position: absolute;left: 0;bottom: -28px;}
.p2 .swiper-slide .left .from{color: #0E4AFA;font-size: 20px;line-height: 30px;font-weight: bold;margin-bottom: 20px;}
.p2 .swiper-slide .left .desc{color: #666;font-size: 18px;line-height: 30px;    overflow: hidden;text-overflow: ellipsis;display: -webkit-box;-webkit-box-orient: vertical;-webkit-line-clamp: 2;word-wrap: break-word;-webkit-hyphens: auto;hyphens: auto;}
.p2 .swiper-slide .left .btn{margin-top: 24px;width: 86px;height: 36px;display: block;border: 1px solid #0E4AFA;color: #0E4AFA;text-align: center;line-height: 36px;font-size: 14px;cursor: pointer;border-radius: 18px;}
.p2 .swiper-slide .left .btn:hover{color: rgba(14, 74, 250, 0.5)}
.p2 .swiper-slide .bottom img{width: 66px;height: 67px;display: inline-block;margin-right: 14px;cursor: pointer;border-radius: 4px;}
.p2 .swiper-slide .bottom img.active{width: 76px;height: 77px;border: 1px solid #0D4AF9}
.p3{background-color: #F8F9FD;padding-top: 60px;padding-bottom: 80px;overflow: visible;font-size: 0;position: relative;}
.p3 h2{text-align: center;font-size: 40px;color: #000;font-weight: bold;margin-bottom: 60px;display: block;}
.p3 .zzCard{display: inline-block;position: relative;z-index: 2;background-color: #fff;border-radius: 10px;box-shadow: 0px 0px 14px 0px rgba(78,112,163,0.2);margin-right: 24px;margin-bottom: 48px;overflow: hidden;padding: 25px 24px;padding-bottom: 0;width: 384px;height: 235px;}
.p3 .zzCard:nth-child(3n+1){margin-right: 0;}
.p3 .zzCard .bg{width: 142px;height: 103px;position: absolute;right: 0;bottom: 0;}
.p3 .zzCard .tit{display: flex;flex-direction: row;align-items: center;margin-bottom: 32px;}
.p3 .zzCard .tit .icon{display: inline-block;width: 34px;height: 34px;margin-right: 16px;}
.p3 .zzCard .tit b{display: inline-block;color: #000;font-size: 20px;font-weight: bold;flex:1;width: 0;}
.p3 .zzCard p{
  color: #666;font-size: 14px;line-height: 24px;
  overflow: hidden;text-overflow: ellipsis;display: -webkit-box;-webkit-box-orient: vertical;-webkit-line-clamp: 2;word-wrap: break-word;-webkit-hyphens: auto;hyphens: auto;}
.p3 .zzCard .btn{
  width: 112px;height: 36px;position: absolute;left: 24px;bottom: 30px;background-color: #0E4AFA;border-radius: 19px;text-align: center;line-height: 38px;color: #fff;font-size: 14px;cursor: pointer;
}
.p3 .zzCard .btn:hover{opacity: 0.8}
.p3After{width: 100%;height: 198px;position: absolute;left: 0;bottom: -118px;z-index: 1}
.p4{padding-bottom: 58px;position: relative;z-index: 1}
.p4 h2{display: block;text-align: center;color: #000;font-size: 40px;font-weight: bold;margin-bottom: 18px;}
.p4 h6{display: block;text-align: center;color: #666666;font-size: 18px;font-weight: normal;margin-bottom: 105px;}
.p4 .img{display: block;margin: 0 auto;width: 1098px;}
.p5{background-color: #F8F9FD;padding-top: 82px;padding-bottom: 40px;}
.p5 h2{display: block;text-align: center;color: #000;font-size: 40px;font-weight: bold;margin-bottom: 18px;}
.p5 h6{display: block;text-align: center;color: #666666;font-size: 18px;font-weight: normal;margin-bottom: 38px;}

.p5 .swiper-slide .p{color: #666;font-size: 16px;line-height: 28px;text-indent: 0;margin-right: 80px;flex:1;}
.p5 .swiper-slide .img{width: 660px;height: 521px;display: inline-block;}
.swiper-container-p5{overflow: hidden;}
.swiper-container-p5,.p5 .swiper-wrapper{width: 1200px;height: 521px;position: relative;margin: 0 auto;background-color: #F8F9FD}
.p5 .swiper-slide{width: 1200px;height: 100%;display: flex;flex-direction: row;align-items: center;position: relative;z-index: 1;}
/* .swiper-container-p5 .swiper-pagination{bottom: 30px;} */
.swiper-container-p5 .swiper-pagination-bullet{width: 12px;height: 12px;background-color: rgba(0,0,0,0.2);opacity: 1;cursor: pointer;}
.swiper-container-p5 .swiper-pagination-bullet-active{width: 24px;height: 12px;background-color: #0E4AFA;opacity: 1;border-radius: 6px;}

/*轮播从app拿到index*/
.indexHeader{width: 100%;min-width: 1200px;height: 550px;position: relative;z-index: 1;}
.indexHeader .swiper-container,.indexHeader .swiper-wrapper{width: 100%;height: 100%;}
.indexHeader .swiper-slide{width: 100%;height: 100%;}
.indexHeader .swiper-slide img{display: block;width: 100%;height: 100%;object-fit: cover;}
.indexHeader .swiper-pagination{bottom: 30px;}
.indexHeader .swiper-pagination-bullet{width: 12px;height: 12px;background-color: rgba(255,255,255,0.5);opacity: 1;cursor: pointer;}
.indexHeader .swiper-pagination-bullet-active{width: 24px;height: 12px;background-color: #fff;opacity: 1;border-radius: 6px;}
.normalHeader{width: 100%;min-width: 1200px;height: 60px;position: relative;z-index: 1;background-color: #777;}
</style>
